module.exports = __webpack_public_path__ + "img/imdb.15718493.svg";